var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { List, Skeleton, Spin } from 'antd';
import React from 'react';
import InfiniteScroll from 'react-infinite-scroll-component';
import { useGroupGeofencePageContext } from '../../GroupGeofencePage.context';
import GeofenceListItem from '../GeofenceListItem/GeofenceListItem';
import TotalGeofence from '../TotalGeofence';
import useGeofenceList from './useGeofenceList';
var GeofenceList = function () {
    var _a = useGeofenceList(), loadMoreData = _a.loadMoreData, geofences = _a.geofences, loading = _a.loading, page = _a.page;
    var context = useGroupGeofencePageContext();
    return (React.createElement(InfiniteScroll, { dataLength: geofences.data.length || 0, next: loadMoreData, hasMore: geofences.data.length < geofences.metaData.totalItems, loader: React.createElement("div", { style: { padding: 16 } },
            React.createElement(Skeleton, { paragraph: { rows: 2 }, active: true })), scrollableTarget: "scrollableDiv" },
        React.createElement(Spin, { spinning: page === 1 && loading },
            React.createElement(List, { className: "geofence-list", header: React.createElement(TotalGeofence, { total: geofences.metaData.totalItems || 0 }), dataSource: geofences.data || [], rowKey: function (item) { return item._id; }, renderItem: function (item, index) {
                    var _a;
                    return (React.createElement(GeofenceListItem, __assign({ selected: item._id === ((_a = context.selectedGeofence) === null || _a === void 0 ? void 0 : _a._id), key: index }, item)));
                } }))));
};
export default GeofenceList;
